import { AssetDto } from "../../../../../../api/src/asset/models/asset.dto";
import { Category } from "../../../_core/state/global/global.model";

export interface AssetTemplateSelectElement {
	id: string;
	name: string;
	description?: string;
	status?: string;
	tags: string[];
	previewUrl?: string;
	thumbnail: AssetDto;
	isFeatured?: boolean;
	isRecent?: boolean;
	fileType: 'image' | 'video' | 'logo' | 'audio' | 'document' | 'other'
	duration?: number;
	modified?: string;
	isPinned?: boolean;
	pinnedAt?: string;

	categories?: { [key: string]: Category };
	originalVersionId?: string;
}

export interface AssetTemplateSelectFilter {
	categories?: { [key: string]: Category };
	search?: string;
	fileTypes?: string[];
	showRecent: boolean;
	customFilters?: {
		[key: string]: string[] | undefined
	}
}

export interface AssetTemplateSelectUiSettings {
	showFilter: boolean;
	showSearch: boolean;
	showFileTypeFilter: boolean;
	showFileType: boolean;
	showRecent: boolean;
	showCategory: boolean;
	showMoreFilters: boolean;
	showSelectViewMode: boolean;
	showAddButton: boolean;
	showCancelButton: boolean;
	showFeatured: boolean;
	groupByCategory: boolean;
	showPreview: boolean;
	showSubmitButton: boolean;
	showPackageMenuActions: boolean;
	showImportButton: boolean;
	showPinButton?: boolean;
	showHeader?: boolean;
	customFilters?: AssetTemplateSelectCustomFilterSettings[];
}

export interface AssetTemplateSelectCustomFilterSettings {
	key: string;
	name: string;
	options: {value: string, label: string }[] | 'auto';
	selectionType: 'single' | 'multiple';
}

export interface AssetTemplateSelectCopySettings {
	title?: string;
	copy?: string;
	elementTitle: string;
	elementTitlePlural: string;
	featuredTitle: string;
	recentTitle: string;
	searchPlaceholder: string;
	noResultsText: string
}

export interface AssetTemplateSelectionChangeEvent {
	selection: any[];
	openSelection: boolean;
}

export type AssetTemplateSelectViewMode = 'card' | 'list' | 'table';

export namespace AssetTemplateSelectViewMode {
	export function getSelectionClass(viewMode: AssetTemplateSelectViewMode): string {
		switch (viewMode) {
			case 'card':
				return 'selections-cards';
			case 'list':
				return 'selections-list';
			case 'table':
				return 'selections-table collection-table-container';
		}
	}

	export function getViewModeIcon(viewMode: AssetTemplateSelectViewMode): string {
		switch (viewMode) {
			case 'card':
				return 'apps';
			case 'list':
				return 'list_ul';
			case 'table':
				return 'table_rows';
		}
	}
}

export type AssetTemplateSelectSelectType = 'single' | 'multiple';
